import { DateTime, DateTimeFormatOptions } from "luxon";

import formatDateTime from "./formatDateTime";

// Formats for the messages inbox, all shown through formatDateTime so they follow the UI language.
export const INBOX_TIME = DateTime.TIME_24_SIMPLE;
export const INBOX_DAY: DateTimeFormatOptions = { weekday: "short", day: "numeric", month: "short" };
export const INBOX_DAY_TIME: DateTimeFormatOptions = { ...INBOX_DAY, hour: "2-digit", minute: "2-digit", hourCycle: "h23" };
const WEEKDAY_TIME: DateTimeFormatOptions = { weekday: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23" };
const DAY_MONTH: DateTimeFormatOptions = { day: "numeric", month: "short" };

const london = (iso: string) => DateTime.fromISO(iso, { zone: "utc" }).setZone("Europe/London");

/** For a list row: the time today, the weekday this week, else the date. */
export function receivedLabel(iso: string, now: DateTime): string {
  const at = london(iso);
  if (at.hasSame(now.setZone("Europe/London"), "day")) return formatDateTime(iso, INBOX_TIME);
  if (now.diff(at, "days").days < 7) return formatDateTime(iso, WEEKDAY_TIME);
  return formatDateTime(iso, DAY_MONTH);
}

/** For a message in the thread: the time today, else the day and time. */
export function messageTimeLabel(iso: string, now: DateTime = DateTime.now()): string {
  return london(iso).hasSame(now.setZone("Europe/London"), "day") ? formatDateTime(iso, INBOX_TIME) : formatDateTime(iso, INBOX_DAY_TIME);
}

/**
 * Dates written into replies to buyers. These stay in English whatever language the person
 * replying uses Wilma in, so they can't go through formatDateTime (which follows the UI language).
 */
export function buyerFacingDate(iso: string, format = "cccc d LLLL"): string {
  return london(iso).setLocale("en-GB").toFormat(format);
}
